type environmentType = {
  API_BASE_URL?: string
  APP_ENVIRONMENT?: string
  IS_PRODUCTION?: string
  [key: string]: string | undefined
}

/**
 * Returns runtime environment variables
 * - Client side → from window.RUNTIME_CONFIG
 * - Server side → from process.env
 */
export function getEnvs(): environmentType {
  if (typeof window !== 'undefined' && (window as any).RUNTIME_CONFIG) {
    return (window as any).RUNTIME_CONFIG
  }
  return process.env
}
